export default __webpack_public_path__ + "static/media/program_banner_Cn.9745a4f7.webp";